import type { AccountSource } from 'owa-account-source-list-store';
import { isCloudCacheAccountType } from 'owa-account-source-list-types';

/**
 * Returns true if the account source is a cloud cache account
 * @param account Account to check
 * @returns True if it is a cloud cache account, false otherwise
 */
export default function isCloudCache(account: AccountSource): boolean {
    return isCloudCacheAccountType(account.sourceType);
}
